import { FormlySelectOption } from '@ngx-formly/core/select';

export const CollateralPropertySubTypeOfIndustrials = [
  {
    value: 'B1_FLATTED_RAMPED_UP_FACTORY',
    label: 'Industrial Property (B1) - Flatted / Ramped up factory',
  },
  {
    value: 'B1_JTC',
    label: 'Industrial Property (B1) - JTC',
  },
  {
    value: 'B1_TERRACE_FACTORY',
    label: 'Industrial Property (B1) - Terrace Factory',
  },
  {
    value: 'B1_FLATTED_WAREHOUSE',
    label: 'Industrial Property (B1) - Flatted Warehouse',
  },
  {
    value: 'B2_FLATTED_RAMPED_UP_FACTORY',
    label: 'Industrial Property (B2) - Flatted / Ramped up factory',
  },
  {
    value: 'B2_JTC',
    label: 'Industrial Property (B2) - JTC',
  },
  {
    value: 'B2_TERRACE_FACTORY',
    label: 'Industrial Property (B2) - Terrace Factory',
  },
  {
    value: 'B2_FLATTED_WAREHOUSE',
    label: 'Industrial Property (B2) - Flatted Warehouse',
  },
];

export const CollateralPropertySubTypeOfCommercials = [
  {
    value: 'NON_HDB',
    label: 'Non HDB',
  },
  {
    value: 'HDB',
    label: 'HDB',
  },
  {
    value: 'COFFEE_SHOP',
    label: 'Coffee Shop',
  },
  {
    value: 'MEDICAL_SUITE',
    label: 'Medical Suite',
  },
  {
    value: 'RETAIL_SHOP',
    label: 'Retail Shop',
  },
  {
    value: 'SHOPHOUSE',
    label: 'Shophouse',
  },
  {
    value: 'OFFICE',
    label: 'Office',
  },
  {
    value: 'SOHO',
    label: 'SOHO',
  },
];

export const CollateralPropertySubTypeOfResidentials = [
  {
    value: 'NON_LANDED',
    label: 'Non-Landed',
  },
  {
    value: 'LANDED',
    label: 'Landed',
  },
];

export const KeyPersonnelRelationshipToApplicants: RelationshipToApplicantOption[] = [
  {
    value: 'DIRECTOR',
    label: 'Director',
    constrain: [],
  },
  {
    value: 'PARTNER',
    label: 'Partner',
    constrain: [{ single: true }],
  },
  {
    value: 'SOLE_PROPRIETOR',
    label: 'Sole-Proprietor',
    constrain: [{ single: true }],
  },
  {
    value: 'SHAREHOLDER',
    label: 'Shareholder',
    constrain: [],
  },
  {
    value: 'SECRETARY',
    label: 'Secretary',
    constrain: [],
  },
  {
    value: 'OTHER',
    label: 'Others',
    constrain: [{ single: true }],
  },
];

export type RelationshipToApplicantOption = { constrain: Record<string, boolean>[] } & FormlySelectOption;
